import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { FileDown } from 'lucide-react';
import { ErrorNotice, Modal, Notice } from '../../components/ui';
import { downloadFile } from '../../lib/api';
import { toRunRequest, useScenario } from '../../state/scenario';

/** PDF export. The acknowledgement is enforced server-side too (BR-002); the checkbox is not the control, only the UX. */
export function ExportDialog({ onClose }: { onClose: () => void }) {
  const { state } = useScenario();
  const [ack, setAck] = useState(false);
  const [withAi, setWithAi] = useState(false);
  const [title, setTitle] = useState('Plant Decision Engine — Screening Report');
  const exp = useMutation({
    mutationFn: () => downloadFile('/reports/pdf', {
      run: toRunRequest(state, false),
      title,
      acknowledge_indicative_inputs: ack,
      include_ai_summary: withAi,
    }, 'plant-decision-report.pdf'),
  });

  return (
    <Modal title="Export screening report (PDF)" onClose={onClose}>
      <form className="stack" onSubmit={(e) => { e.preventDefault(); exp.mutate(); }}>
        <label className="field"><span>Report title</span><input type="text" maxLength={160} value={title} onChange={(e) => setTitle(e.target.value)} /></label>
        <label className="checkbox"><input type="checkbox" checked={withAi} onChange={(e) => setWithAi(e.target.checked)} />
          <span>Include executive summary (AI narrative if it passes the numeric check, otherwise the engine-written summary; may take up to two minutes)</span></label>
        <Notice tone="warn" icon={false}>
          <label className="checkbox"><input type="checkbox" checked={ack} onChange={(e) => setAck(e.target.checked)} required />
            <span>I understand that grade B inputs are indicative and grade C inputs are placeholders, and that they must be verified before this report is used externally.</span></label>
        </Notice>
        <ErrorNotice error={exp.error} />
        {exp.isSuccess && <Notice tone="success">Report downloaded.</Notice>}
        <div className="modal-actions">
          <button type="button" className="button secondary" onClick={onClose}>Close</button>
          <button type="submit" className="button primary" disabled={!ack || exp.isPending}><FileDown size={15} aria-hidden />{exp.isPending ? 'Generating…' : 'Download PDF'}</button>
        </div>
      </form>
    </Modal>
  );
}
